import { render } from "./ContainerComponent.vue?vue&type=template&id=34f79219"
import script from "./ContainerComponent.vue?vue&type=script&lang=js"
export * from "./ContainerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__